import React, { Suspense } from 'react';
import { renderRoutes } from 'utils/router';
import { useRoutes } from 'routes';
// import LeftMenu from './LeftMenu';
import Loading from 'components/Loading';
import less from './index.module.less';

const Content = () => {
    const routes = useRoutes();
    return (
        <div className={less.container}>
            {/* <LeftMenu /> */}
            <div className={less.detail}>
                <Suspense fallback={<Loading />}>{renderRoutes(routes)}</Suspense>
            </div>
        </div>
    );
};

export default Content;
